{
  "assetType": {
    "stocks": "Stocks",
    "options": "Options"
  }
}
